import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { convertToOption } from "src/utils/convertToOption";
import { errorResponsesTrns } from "src/translate/responses";
import { ISoldInformation } from "src/@types/soldInformation";

export const SOLD_INFORMATIONS_SLICE_NAME = "soldInformations";

export const getSoldInformationsAsync = createAsyncThunk(
  `${SOLD_INFORMATIONS_SLICE_NAME}/fetchSoldInformations`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<ISoldInformation[]>(
        "/sold-information/"
      );
      //CHANGE - temp use convertToOption
      return convertToOption(data);
    } catch ({ response }) {
      const errorText =
        response?.data?.error || errorResponsesTrns.soldInformations;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);
